// extracted by mini-css-extract-plugin
var _1 = "EmptyNotes_emptyContainer__9rUxy";
var _2 = "EmptyNotes_text__zNN4U";
export { _1 as "emptyContainer", _2 as "text" }
